import { ACTIONS } from 'a/pictureThis/data/constants';

export const initialState = {
  collection: [],
  validCollectionTypes: [],
  isShowingLast: false,
};

const stickerCollection = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTIONS.COLLECT_ELEMENT:
      if (isElementAlreadyCollected(state, payload)) {
        return state;
      }
      return {
        ...state,
        collection: [...state.collection, payload],
        isShowingLast: true,
      };
    case ACTIONS.NEXT_STORY_ELEMENT:
      return {
        ...state,
        isShowingLast: false,
      };
    case ACTIONS.SELECT_LEVEL:
    case ACTIONS.ADVANCE_CONTENT:
      return initialState;
    default:
      return state;
  }
};

export default stickerCollection;

// helper functions
export const isElementAlreadyCollected = ({ collection }, element) =>
  collection.indexOf(element) > 0;

// selectors
export const getCollectedElements = state => state.collection;

export const getIsShowingImage = state => state.isShowingLast;
